import { withRouter } from 'react-router-dom';
import { Fragment, useState } from "react";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { UserDetailsDropDown } from '../../../components/molecules/user/UserDropDown';





const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100vh',
        float: 'left'

    },
    selectedIconButton: {
        backgroundColor: '#48566a',
    },
    image: {
        width: 44,
        height: 44
    },
    expandIcon: {
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        // backgroundColor: '#fff',
        width: 25,
        height: 15,
        // marginLeft: '-30px',
        zIndex: 20,
        // left: 50
    },
    list: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    listItem: {
        '&:hover': {
            backgroundColor: '#3f4e5c', // set your desired hover color
        },
    }

}));

const DashboardDrawerMenu = (props) => {



    const classes = useStyles();
    const theme = useTheme();
    const [importer, setImporter] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(500);
    const [openUserPop, setopenUserPop] = useState(null);

    const onPress = (path) => props.history.replace(path);
    const isSelected = (path) => props.location.pathname === path;



    const handleListItemClick = (event, index) => {
        console.log('index-->', index)
        setSelectedIndex(index);
    };

    const handleClickUserPop = (event) => {
        setopenUserPop(event.currentTarget);
    };

    const userPopOverClose = () => {
        setopenUserPop(null);
        setSelectedIndex(10);
    };

    return (
        <>
            {openUserPop && <UserDetailsDropDown anchorEl={openUserPop} handleClose={userPopOverClose} />}
            <Box flexGrow={1} id="sidebar-dashboard" >
                <List className={classes.list}>
                    <Tooltip title="Dashboard" placement="right">
                        <ListItem
                            button
                            id="dashboardScreen"
                            onClick={(event) => { handleListItemClick(event, 0); onPress("/") }}
                            style={{ marginTop: 64, background: isSelected("/") ? '#ffff00' : '', justifyContent: 'center' }}
                            // selected={selectedIndex === 0}
                            className={classes.listItem}
                            data-ui-tour-id='sb-dashboard-btn'
                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {!isSelected("/") && <img src={`${process.env.PUBLIC_URL}/ide_icons/dashboard_color.svg`} className={classes.image} />}
                                {isSelected("/") && <img src={`${process.env.PUBLIC_URL}/ide_icons/dashboard_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>

                    {/* <ListItem
                        button
                        onClick={(event) => { handleListItemClick(event, 1); onPress("/") }}
                        selected={selectedIndex === 1}
                        style={{ background: selectedIndex == 1 ? '#ffff00' : '' }}
                        className={classes.listItem}
                    >
                        <ListItemIcon style={{ minWidth: 10 }}>
                            {selectedIndex != 1 && <img src={`${process.env.PUBLIC_URL}/ide_icons/systemmodel_color.svg`} className={classes.image} />}
                            {selectedIndex == 1 && <img src={`${process.env.PUBLIC_URL}/ide_icons/systemmodel_dark.svg`} className={classes.image} />}
                        </ListItemIcon>

                    </ListItem> */}
                    <Tooltip title="Configuration" placement="right">
                        <ListItem
                            button
                            id="configuration"
                            onClick={(event) => { handleListItemClick(event, 2); onPress("/configuration") }}
                            // selected={selectedIndex === 2}
                            style={{ marginTop: 'auto', flex: 1, background: isSelected("/configuration") ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem}
                            data-ui-tour-id='sb-configuration-btn'
                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {!isSelected("/configuration") && <img src={`${process.env.PUBLIC_URL}/ide_icons/deploy_color.svg`} className={classes.image} />}
                                {isSelected("/configuration") && <img src={`${process.env.PUBLIC_URL}/ide_icons/deploy_new.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>

                    <Tooltip title="Backup and Restore" placement="right">
                        <ListItem
                            button
                            id="backupRestoreScreen"
                            onClick={(event) => { handleListItemClick(event, 3); onPress("/backup-and-restore") }}
                            selected={selectedIndex === 3}
                            style={{ marginTop: 'auto', flex: 1, background: isSelected("/backup-and-restore") ? '#ffff00' : '', justifyContent: 'center' }}
                            className={classes.listItem}
                            data-ui-tour-id='sb-backups-btn'
                        >
                            <ListItemIcon style={{ minWidth: 10 }}>
                                {!isSelected("/backup-and-restore") && <img src={`${process.env.PUBLIC_URL}/ide_icons/backup_restore_color.svg`} className={classes.image} />}
                                {isSelected("/backup-and-restore") && <img src={`${process.env.PUBLIC_URL}/ide_icons/backup_restore_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>
                </List>
            </Box>
            {/* <Box >
                <List className={classes.list}>
                    <ListItem
                        button
                        onClick={(event) => handleListItemClick(event, 4)}
                        selected={selectedIndex === 4}
                        style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 4 ? '#ffff00' : '', justifyContent: 'center' }}
                        className={classes.listItem}
                    >
                        <ListItemIcon style={{ minWidth: 20 }}>
                            {selectedIndex != 4 && <img src={`${process.env.PUBLIC_URL}/ide_icons/deploy_color.svg`} className={classes.image} />}
                            {selectedIndex == 4 && <img src={`${process.env.PUBLIC_URL}/ide_icons/deploy_new.svg`} className={classes.image} />}
                        </ListItemIcon>

                    </ListItem>
                </List>
            </Box> */}

            <Box >
                <List className={classes.list} >
                    <Tooltip title="Documentation" placement="right">
                        <ListItem
                            button
                            id="documentation"
                            className={classes.listItem}
                            onClick={() => window.open('/docs/getting-started/', '_blank')}
                            style={{ marginTop: 'auto', flex: 1, justifyContent: 'center' }}
                        >
                            <ListItemIcon style={{ minWidth: 20 }}>
                                <img src={`${process.env.PUBLIC_URL}/ide_icons/documentation_info.svg`} className={classes.image} />
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>
                    <Tooltip title="User" placement="right">
                        <ListItem
                            button
                            id="user"
                            onClick={(event) => { handleListItemClick(event, 4); handleClickUserPop(event) }}
                            selected={selectedIndex === 4}
                            data-ui-tour-id='sb-user-btn'
                            style={{ marginTop: 'auto', flex: 1, background: selectedIndex == 5 ? '#ffff00' : '', justifyContent: 'center' }}
                        >
                            <ListItemIcon style={{ minWidth: 20 }}>
                                {selectedIndex != 4 && <img src={`${process.env.PUBLIC_URL}/ide_icons/user_color.svg`} className={classes.image} />}
                                {selectedIndex == 4 && <img src={`${process.env.PUBLIC_URL}/ide_icons/user_dark.svg`} className={classes.image} />}
                            </ListItemIcon>

                        </ListItem>
                    </Tooltip>
                </List>
            </Box>
        </>

    )
}

export default withRouter(DashboardDrawerMenu);